import React from 'react';
import { motion } from 'framer-motion';
import { useNarrowMobile } from '../hooks/useNarrowMobile';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const darkColor = '#111111';
  const narrowMobile = useNarrowMobile();

  // Force scroll to top when component mounts
  React.useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    document.body.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, []);

  // Full-screen motion wipes + opacity wrapper promote layers and hurt touch scrolling on phones.
  if (narrowMobile) {
    return <>{children}</>;
  }

  return (
    <>
      {/* Exit Wipe (slides down from top) */}
      <motion.div
        initial={{ scaleY: 0 }}
        animate={{ scaleY: 0 }}
        exit={{ scaleY: 1 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: darkColor,
          transformOrigin: 'top',
          zIndex: 9999,
          pointerEvents: 'none',
        }}
        aria-hidden
      />

      {/* Enter Wipe (Slides away to top) */}
      <motion.div
        initial={{ scaleY: 1 }}
        animate={{ scaleY: 0 }}
        exit={{ scaleY: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: darkColor,
          transformOrigin: 'top',
          zIndex: 9999,
          pointerEvents: 'none',
        }}
        aria-hidden
      />

      {/* Content Animation */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default PageTransition;
